//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "CategoryCollectionsFilterFilters",
  components: {
    DatePickerComponent: () => import("@/components/common/DatePickerComponent"),
    Button: () => import("@/components/common/Button/index.vue"),
    Toggle: () => import("@/components/common/Toggle/index.vue"),
    FilterToggle: () => import("@/components/common/FilterToggle/index.vue"),
    SelectCheckBoxComponent: () => import("@/components/common/SelectCheckBoxComponent/index.vue"),
    SelectSearchComponent: () => import("@/components/common/SelectSearchComponent/index.vue"),
  },
  computed: {
    ...mapGetters({
      tourism_types: 'tourism-types/tourism_types',
      tourism_type_id: 'pages/category-collections/tourism_type_id',
      cities: 'cities/cities',
      city_id: 'pages/category-collections/city_id',
      title: 'pages/category-collections/title',
      items: 'pages/category-collections/items',
      pending: 'pages/category-collections/pending',
      meta: 'pages/category-collections/meta',
      page: 'pages/category-collections/page',
      count: 'pages/category-collections/count',
      entity: 'pages/category-collections/entity',
      slug: 'pages/category-collections/slug',
      sort: 'pages/category-collections/sort',
      promo: 'pages/category-collections/promo',
      query: 'pages/category-collections/query',
      open_now: 'pages/category-collections/open_now',
      accessible_environment: 'pages/category-collections/accessible_environment',
      category_id: 'pages/category-collections/category_id',
      categoriesCheckBox: 'pages/category-collections/categoriesCheckBox',
      seasons: 'pages/category-collections/seasons',
      season_id: 'pages/category-collections/season_id',
      levels: 'pages/category-collections/levels',
      level_id: 'pages/category-collections/level_id',
      age_restrictions: 'pages/category-collections/age_restrictions',
      age_restriction_id: 'pages/category-collections/age_restriction_id',
      has_events: 'pages/category-collections/has_events',
      place_id: 'pages/category-collections/place_id',
      dates: 'pages/category-collections/dates',
      has_tickets: 'pages/category-collections/has_tickets',
      city: 'cities/default'
    }),
    citiesWithAll() {
      return [{
        id: null,
        title: this.$t(`pages.category-collections-view.${this.entity}.select-city-default`)
      }, ...this.cities]
    },
    tourismWithAll() {
      return [{
        id: null,
        title: this.$t(`pages.category-collections-view.${this.entity}.select-tourism-default`)
      }, ...this.tourism_types]
    },
    seasonsWithAll() {
      return [{
        id: null,
        title: this.$t(`pages.category-collections-view.${this.entity}.select-seasons-default`)
      }, ...this.seasons]
    },
    levelsWithAll() {
      return [{
        id: null,
        title: this.$t(`pages.category-collections-view.${this.entity}.select-level-default`)
      }, ...this.levels]
    },
    ageRestrictionsWithAll() {
      return [{
        id: null,
        title: this.$t(`pages.category-collections-view.${this.entity}.select-age-default`)
      }, ...this.age_restrictions]
    },
    hasEventsWithALL() {
      return [{
        id: null,
        title: this.$t(`pages.category-collections-view.${this.entity}.select-component.has_events.default-text`),
      }, ...this.has_events]
    },
    sortTypes() {
      return [
        {
          id: 'avg',
          text: this.$t(`pages.category-collections-view.${this.entity}.toggle-sort-avg`)
        },
        {
          id: 'created_at',
          text: this.$t(`pages.category-collections-view.${this.entity}.toggle-sort-created-at`)
        }
      ]
    },
    showSortType() {
      const entities = ['places', 'routes', 'excursions']
      return entities.includes(this.entity)
    },
    showPromo() {
      const entities = ['places', 'routes', 'excursions']
      return entities.includes(this.entity)
    },
    showOpenNow() {
      const entities = ['places']
      return entities.includes(this.entity)
    },
    showAccessibleEnvironment() {
      const entities = ['places', 'routes', 'excursions']
      return entities.includes(this.entity)
    },
    showCategoryId() {
      const entities = ['places', 'routes', 'excursions', 'events']
      return entities.includes(this.entity) && this.categoriesCheckBox.length > 1
    },
    showCitySelector() {
      const entities = ['places', 'routes', 'excursions', 'events']
      return entities.includes(this.entity) && this?.cities?.length > 1
    },
    showTourismTypeId() {
      const entities = ['places', 'routes', 'excursions']
      return entities.includes(this.entity)
    },
    showSeasonId() {
      const entities = ['routes', 'excursions', 'events']
      return entities.includes(this.entity)
    },
    showLevelId() {
      const entities = ['routes', 'excursions']
      switch (this.entity) {
        case "routes": {
          return this.$config.ROUTES_LEVEL_FILTER;
        }
        case "excursions": {
          return this.$config.EXCURSIONS_LEVEL_FILTER;
        }
        default: {
          return entities.includes(this.entity)
        }
      }
    },
    showAgeRestrictionId() {
      const entities = ['routes', 'excursions', 'events']
      switch (this.entity) {
        case "routes": {
          return this.$config.ROUTES_AGE_FILTER;
        }
        case "excursions": {
          return this.$config.EXCURSIONS_AGE_FILTER;
        }
        default: {
          return entities.includes(this.entity);
        }
      }
    },
    showHasEvents() {
      const entities = ['events']
      return entities.includes(this.entity)
    },
    showDates() {
      const entities = ['events', 'excursions']
      return entities.includes(this.entity)
    },
    showHasTickets() {
      const entities = ['excursions']
      return entities.includes(this.entity)
    }
  },
  created() {
    if (process.browser) {
      const query = this.$route.query
      if (query.slug) {
        const cityId = this?.cities?.find(item => item.slug === this.$route.query.slug)?.id
        this.$store.commit('pages/category-collections/setCityId', cityId)
      } else {
        if (this.$config.singleCity) {
          this.$store.commit('pages/category-collections/setCityId', this.$defaultCityId())
        } else {
          this.$store.commit('pages/category-collections/setCityId', query.city_id)
        }
      }
    }
  },
  mounted() {
    this.$store.commit('pages/category-collections/createCategoriesCheckBox')
  },
  methods: {
    reset() {
      this.$store.commit('pages/category-collections/setPage', 1)
      this.$store.commit('pages/category-collections/setAccessibleEnvironment', false)
      this.$store.commit('pages/category-collections/createCategoriesCheckBox')
      this.$store.commit('pages/category-collections/setCityId', this.$config.singleCity ? this.city.id : null)
      this.$store.commit('pages/category-collections/setOpenNow', false)
      this.$store.commit('pages/category-collections/setPromo', false)
      this.$store.commit('pages/category-collections/setHasTickets', false)
      this.$store.commit('pages/category-collections/setSort', 'avg')
      this.$store.commit('pages/category-collections/setTourismTypes', null)
      this.$store.commit('pages/category-collections/setSeasonId', null)
      this.$store.commit('pages/category-collections/setLevelId', null)
      this.$store.commit('pages/category-collections/setAgeRestrictionId', null)
      this.$store.commit('pages/category-collections/setDates', this.entity === 'excursions' ?
        null :
        [this.$moment().format('YYYY-MM-DD'), null])
      this.$router.replace({query: {}}).catch(() => null)
      this.$store.commit('pages/category-collections/clear')
      this.$store.dispatch('pages/category-collections/submit')
    },
    changeSort(sort) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setSort', sort)
      this.$instantReplaceQuery({sort})
    },
    changePromo(promo) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setPromo', promo)
      this.$instantReplaceQuery({promo})
    },
    changeOpenNow(open_now) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setOpenNow', open_now)
      this.$instantReplaceQuery({open_now})
    },
    changeAccessibleEnvironment(accessible_environment) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setAccessibleEnvironment', accessible_environment)
      this.$instantReplaceQuery({accessible_environment})
    },
    changeCityId(selected) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setCityId', selected.id)
      if (!this.$config.singleCity) {
        this.$instantReplaceQuery({city_id: selected.id})
      }
    },
    changeHasTickets(has_tickets) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setHasTickets', has_tickets)
      this.$instantReplaceQuery({has_tickets})
    },
    changeDates(dates) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setDates', dates)
      if (this.entity === 'events') {
        this.$instantReplaceQuery({
          started_at: dates[0],
          stopped_at: dates[1],
        })
      }
      if (this.entity === 'excursions') {
        this.$instantReplaceQuery({
          schedule_started_at: dates[0],
          schedule_stopped_at: dates[1],
        })
      }
    },
    changeCategoryId(categoryId) {
      this.$store.commit('pages/category-collections/setPage', null)
      this.$store.commit('pages/category-collections/setCategoriesCheckBox', categoryId)
      this.$instantReplaceQuery({category_id: this.$categoryIdToString(categoryId)})
    },
    changeTourismTypeId(tourismType) {
      this.$store.commit('pages/category-collections/setPage', null)
      const tourism_type_id = tourismType?.id || null
      this.$store.commit('pages/category-collections/setTourismTypes', tourism_type_id)
      this.$instantReplaceQuery({tourism_type_id})
    },
    changeSeasonId(season) {
      this.$store.commit('pages/category-collections/setPage', null)
      const season_id = season?.id || null
      this.$store.commit('pages/category-collections/setSeasonId', season_id)
      this.$instantReplaceQuery({season_id})
    },
    changeLevelId(level) {
      this.$store.commit('pages/category-collections/setPage', null)
      const level_id = level?.id || null
      this.$store.commit('pages/category-collections/setLevelId', level_id)
      this.$instantReplaceQuery({level_id})
    },
    changeAgeRestrictionId(ageRestriction) {
      this.$store.commit('pages/category-collections/setPage', null)
      const age_restriction_id = ageRestriction?.id || null
      this.$store.commit('pages/category-collections/setAgeRestrictionId', age_restriction_id)
      this.$instantReplaceQuery({age_restriction_id})
    },
    changePlaceId(place) {
      this.$store.commit('pages/category-collections/setPage', null)
      const place_id = place?.id || null
      this.$store.commit('pages/category-collections/setPlaceId', place_id)
      this.$instantReplaceQuery({place_id})
    },
    submit() {
      this.$store.commit('pages/category-collections/setPage', 1)
      this.$store.dispatch('pages/category-collections/submit')
      this.$store.commit('pages/category-collections/clear')
    }
  }
}
